(function () {
  if (window.__scrollRevealInit) return;
  window.__scrollRevealInit = true;

  var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  var observer = null;

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      // A percentage threshold can never be reached by a section taller
      // than the viewport. Reveal once its leading edge enters view.
      { threshold: 0, rootMargin: '0px 0px -24px 0px' }
    );
    return observer;
  }

  // `scope` limits the search to one freshly-inserted section; defaults to
  // the whole document for the initial pass.
  function scan(scope) {
    var root = scope || document;
    var elements = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    if (root.matches && root.matches('[data-reveal]')) elements.unshift(root);
    if (motionPreference.matches || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(elements, reveal);
      return;
    }
    var io = getObserver();
    Array.prototype.forEach.call(elements, function (el) {
      // Survives a scan of an ancestor that contains already-observed
      // elements. Elements keep the flag after being revealed and
      // unobserved, which is correct — they must not be re-observed.
      if (el.__scrollRevealObserved) return;
      el.__scrollRevealObserved = true;
      io.observe(el);
    });
  }

  function init() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Bug this fixes: elements with [data-reveal] start at opacity 0 and only
  // become visible once this observer adds .is-visible. The scan above ran
  // exactly once, at page load — but the theme editor replaces a section's
  // entire markup when you edit it, and those brand-new nodes were never
  // observed. The result was that editing the hero made it disappear
  // completely and stay blank until a full page reload, which reads as the
  // section being broken rather than as a missed observer.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!observer) return;
    event.target.querySelectorAll('[data-reveal]').forEach(function (el) {
      observer.unobserve(el);
    });
  });

  motionPreference.addEventListener('change', function () {
    if (!motionPreference.matches) return;
    if (observer) observer.disconnect();
    scan(document);
  });
})();
